import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { FaSearch } from "react-icons/fa";
import { categorizedCasinoData } from "../../lib/data/casinoTabs.data";
import { FaChevronDown } from "react-icons/fa";
import { FaChevronUp } from "react-icons/fa";
import FilterPrvdr from "../../assets/images/icons/filter-prvdr.svg";
import FilterCtgry from "../../assets/images/icons/filter-ctgry.svg";

const FILTER_TYPES = {
  PROVIDERS: "providers",
  CATEGORIES: "categories",
  SEARCH: "search",
};

const providers = [
  "ezugi",
  "evolution",
  "kingmaker",
  "supernowa",
  "slots",
  "vivo",
];
const categories = [
  "roulette",
  "andarbahar",
  "livecasino",
  "slots",
  "baccarat",
  "blackjack",
  "other",
  "crash",
];

const GamesSearchModal = () => {
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);
  const [filteredData, setFilteredData] = useState(null);

  const games = {
    ...categorizedCasinoData?.roulette,
    ...categorizedCasinoData?.andarbahar,
    ...categorizedCasinoData?.livecasino,
    ...categorizedCasinoData?.slots,
    ...categorizedCasinoData?.baccarat,
    ...categorizedCasinoData?.blackjack,
    ...categorizedCasinoData?.other,
    ...categorizedCasinoData?.crash,
  };
  const [isShowProvider, setIsShowProvider] = useState(false);
  const [isShowCategory, setIsShowCategory] = useState(false);
  const [selectedProviders, setSelectedProviders] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);

  const [searchGame, setSearchGame] = useState("");

  useEffect(() => {
    return () => {
      setFilteredData(null);
    };
  }, []);

  const handleClose = () => {
    setFilteredData(null);
    setShow(false);
  };

  useEffect(() => {
    filterData(games);
  }, [selectedProviders, selectedCategories, searchGame]);

  const filterData = (dataToFilter) => {
    const filteredGames = Object.values(dataToFilter).filter((game) => {
      return (
        (selectedProviders.length === 0 ||
          selectedProviders.includes(game.provider)) &&
        (selectedCategories.length === 0 ||
          selectedCategories.includes(game.category)) &&
        game.name &&
        game.name.toLowerCase().includes(searchGame.toLowerCase())
      );
    });
    setFilteredData(filteredGames);
  };

  const handleDropDownChange = (value, dropDownType) => {
    if (dropDownType === FILTER_TYPES.CATEGORIES) {
      setSelectedCategories((prev) =>
        prev.includes(value)
          ? prev.filter((c) => c !== value)
          : [...prev, value]
      );
    } else if (dropDownType === FILTER_TYPES.PROVIDERS) {
      setSelectedProviders((prev) =>
        prev.includes(value)
          ? prev.filter((p) => p !== value)
          : [...prev, value]
      );
    }
  };

  return (
    <>
      <div className="search-box">
        <div className="searchGames" onClick={handleShow}>
          <FaSearch />
        </div>
      </div>

      <Modal
        show={show}
        fullscreen={true}
        onHide={handleClose}
        className="search-modal "
      >
        <Modal.Header closeButton closeVariant="white">
          <Modal.Title>Search for games</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="searchbox">
            <div className="filter-sec">
              <div className="filter-bar">
                <input
                  type="text"
                  placeholder="Start writing a game or provider name"
                  value={searchGame}
                  onChange={(e) => setSearchGame(e.target.value)}
                />

                {/* Provider Filters */}
                <div
                  className="provider filter"
                  onClick={() => {
                    setIsShowProvider(!isShowProvider);
                    setIsShowCategory(false);
                  }}
                >
                  <img src={FilterPrvdr} alt="provider filter" />
                  Providers
                  {isShowProvider ? <FaChevronUp /> : <FaChevronDown />}
                </div>
                <div
                  className="category filter"
                  onClick={() => {
                    setIsShowCategory(!isShowCategory);
                    setIsShowProvider(false);
                  }}
                >
                  <img src={FilterCtgry} alt="categories filter" />
                  Categories
                  {isShowCategory ? <FaChevronUp /> : <FaChevronDown />}
                </div>
              </div>

              <div className="more-filter">
                <ul>
                  {isShowProvider &&
                    providers.map((provider) => (
                      <li>
                        <label
                          key={provider}
                          style={{ textTransform: "capitalize" }}
                        >
                          <input
                            type="checkbox"
                            checked={selectedProviders.includes(provider)}
                            onChange={() =>
                              handleDropDownChange(
                                provider,
                                FILTER_TYPES.PROVIDERS
                              )
                            }
                          />
                          {provider}
                        </label>
                      </li>
                    ))}
                </ul>
                <ul>
                  {isShowCategory &&
                    categories.map((category) => (
                      <li>
                        <label
                          key={category}
                          style={{ textTransform: "capitalize" }}
                        >
                          <input
                            type="checkbox"
                            checked={selectedCategories.includes(category)}
                            onChange={() =>
                              handleDropDownChange(
                                category,
                                FILTER_TYPES.CATEGORIES
                              )
                            }
                          />
                          {category}
                        </label>
                      </li>
                    ))}
                </ul>
              </div>
            </div>

            <div className="game-list">
              {filteredData?.map((game) => (
                <a key={game.id} href={game?.href}>
                  <img
                    src={game?.imgUrl?.slice(1, game?.imgUrl?.length)}
                    height={154}
                  />
                </a>
              ))}
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default GamesSearchModal;
